var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 20.4986L34.1135 16.7171L36.2374 11.1248L30.3315 10.1675L29.3748 4.26161L23.7815 6.38615L20 1.75006L19.4242 2.45612L16.2176 6.38615L10.6257 4.26168L9.66802 10.1676L3.76309 11.1248L5.8866 16.7172L1.25 20.4986L5.8866 24.2805L3.76309 29.8734L9.66802 30.8311L10.6253 36.7365L16.2176 34.6125L20 39.2482L23.7815 34.6125L29.3748 36.7365L30.3315 30.8311L36.2379 29.8734L34.1135 24.2805L38.75 20.4986ZM34.2006 28.6975L29.0355 29.5351L28.1988 34.6997L23.3073 32.8419L20 36.8967L16.6918 32.8418L11.8012 34.6997L10.964 29.5351L5.79944 28.6979L7.65671 23.8058L3.60239 20.4991L7.65679 17.1919L5.79951 12.3007L10.964 11.4636L11.8013 6.29899L16.6919 8.15634L20 4.10201L23.3073 8.15641L28.1988 6.29855L29.0355 11.4636L34.2006 12.3007L32.3432 17.1919L36.3976 20.4991L32.3432 23.8058L34.2006 28.6975Z",
    fill: "#54545C",
    stroke: "#54545C",
    strokeWidth: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.2666L18.3103 24.3999L27 15.9999",
    stroke: "#54545C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.819fcf1616f21c5d973e50546cd396a9.svg";
export { ForwardRef as ReactComponent };